import React from 'react';
import Navbar from './home/Navbar';
import Footer from './Footer';
import ZendeskActionFlows from './ZendeskActionFlows';
import useGoogleAnalytics from '../hooks/useGoogleAnalytics';

function ZendeskActionFlowsPage() {
  const { events } = useGoogleAnalytics();

  React.useEffect(() => {
    window.scrollTo(0, 0);
    events.pageView('Zendesk Action Flows');
  }, [events]);

  return (
    <div className="flex flex-col min-h-screen bg-ink font-sans text-white antialiased">
      <Navbar />
      <div className="flex-grow pt-16">
        <ZendeskActionFlows />
      </div>
      <Footer />
    </div>
  );
}

export default ZendeskActionFlowsPage;
